import { createReducer } from 'redux-act';

import {
  clearBasket,
  clearCreatedOrders,
  createBasketSnapshot,
  keepCreatedOrder,
  selectPayment,
  selectRequestedTime,
  setBasket,
  setCancelOrderErrorMessage,
  setExcludeServiceCharge,
  setOrderLoading,
  setOrderProcessing,
  setRoundUpEnabled,
  setStatus,
  setSubmittedOrder,
  setValidationErrors,
  updateBasket,
} from './actions';

export const defaultBasketState: WebOrder.State.Basket = {
  createdOrders: {},
  excludeServiceCharge: false,
  items: {},
  status: 'none',
  validationErrors: [],
};

const basketReducer = createReducer({}, defaultBasketState);
export { basketReducer };

basketReducer.on(setBasket, (_state, payload) => ({
  ...payload,
}));

basketReducer.on(clearBasket, (state, payload) => ({
  ...state,
  ...payload,
}));

basketReducer.on(createBasketSnapshot, (state, payload) => ({
  ...state,
  basketSnapshot: payload,
}));

basketReducer.on(updateBasket, (state, payload) => ({
  ...state,
  ...payload,
}));

basketReducer.on(setStatus, (state, payload) => ({
  ...state,
  ...payload,
}));

basketReducer.on(setValidationErrors, (state, validationErrors) => ({
  ...state,
  validationErrors,
}));

basketReducer.on(selectPayment, (state, payload) => ({
  ...state,
  ...payload,
}));

basketReducer.on(selectRequestedTime, (state, payload) => ({
  ...state,
  ...payload,
}));

basketReducer.on(setExcludeServiceCharge, (state, payload) => ({
  ...state,
  excludeServiceCharge: payload,
}));

basketReducer.on(setOrderLoading, (state, orderLoading) => ({
  ...state,
  orderLoading,
}));

basketReducer.on(keepCreatedOrder, (state, payload) => {
  if (!state.serviceCharge) {
    return {
      ...state,
      createdOrders: {
        ...state.createdOrders,
        ...payload,
      },
      serviceCharge: {
        ...Object.values(payload)[0].ServiceCharge,
      },
    };
  }

  return {
    ...state,
    createdOrders: {
      ...state.createdOrders,
      ...payload,
    },
    serviceCharge: {
      ...state.serviceCharge,
      AmountExcludingProcessingFee: Object.values(payload)[0].ServiceCharge
        .AmountExcludingProcessingFee,
    },
  };
});

basketReducer.on(clearCreatedOrders, (state) => ({
  ...state,
  createdOrders: {},
}));

basketReducer.on(setSubmittedOrder, (state, submittedOrder) => ({
  ...state,
  submittedOrder,
  error: undefined,
}));

basketReducer.on(setOrderProcessing, (state, isOrderProcessing) => ({
  ...state,
  isOrderProcessing,
}));

basketReducer.on(setRoundUpEnabled, (state, isRoundUpEnabled) => ({
  ...state,
  isRoundUpEnabled,
}));

basketReducer.on(
  setCancelOrderErrorMessage,
  (state, cancelOrderErrorMessage) => ({
    ...state,
    cancelOrderErrorMessage,
  }),
);
